import MoveFileDialog from './MoveFileDialog';
import MoveFileCollectionDialog from './MoveFileCollectionDialog';

export type MoveContentDialogProps = {
  fileId?: number;
  fileCollectionId?: number;
  onClose: () => void;
};

export default function MoveContentDialog({
  fileId,
  fileCollectionId,
  onClose,
}: MoveContentDialogProps) {
  if (fileId) return <MoveFileDialog fileId={fileId} onClose={onClose} />;
  if (fileCollectionId) {
    return (
      <MoveFileCollectionDialog
        fileCollectionId={fileCollectionId}
        onClose={onClose}
      />
    );
  }
  return null;
}
